import { FileText } from "lucide-react";

export interface MetaCustomerInfoPreviewProps {
  instance: {
    customer_name?: string;
    customer_address?: string;
    customer_contact_info?: string;
  };
}

export function MetaCustomerInfoPreview({ instance }: MetaCustomerInfoPreviewProps) {
  return (
    <div className="mb-4">
      <div className="flex items-center gap-2 mb-3">
        <FileText className="h-4 w-4 text-muted-foreground" />
        <span className="text-sm font-medium">Customer Information</span>
      </div>
      <div className="bg-muted/10 rounded-lg border border-border p-4">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
          <div className="space-y-2">
            <div className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
              Customer Name
            </div>
            <div className="text-sm font-medium">
              {instance.customer_name || '-'}
            </div>
          </div>
          <div className="space-y-2">
            <div className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
              Address
            </div>
            <div className="text-sm font-medium whitespace-pre-wrap break-words max-h-[100px] overflow-y-auto">
              {instance.customer_address || '-'}
            </div>
          </div>
          <div className="space-y-2">
            <div className="text-xs font-medium text-muted-foreground uppercase tracking-wider">
              Contact Information
            </div>
            <div className="text-sm font-medium whitespace-pre-wrap break-words max-h-[100px] overflow-y-auto">
              {instance.customer_contact_info || '-'}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
